import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { useRef, useState, useEffect } from 'react';
import '../../App.css';
import '../../css/bootstrap.scss';
import { Link } from 'react-router-dom';
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import lock from "../../images/lock.png";
import { useNavigate } from 'react-router-dom';
import config from '../../config';
import axios from 'axios';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import renderField from '../renderField';
import { connect } from 'react-redux';
import { setEmail, setwizardPageNumber, setFaceID } from '../LoginReducer';
import { RootState } from '../store';
import { useDispatch, useSelector } from 'react-redux';
import { ToastBox, notifyError, notifySuccess } from 'MyComponents/Toaster';
import CameraModal from '../Camera/CameraModal';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

interface FormData { }

interface Props { };

const SignInMultifactorAuthenticatorVerification: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { handleSubmit } = props;
    const dispatch = useDispatch();
    const page = useSelector((state: RootState) => state.loginAccount.wizardPageNumber);
    const accessToken = useSelector((state: RootState) => state.loginAccount.accessToken);

    const [isSubmitted, setIsSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const [validatedEmpty, setValidatedEmpty] = useState(false);
    const [validatedSuccess, setValidatedSuccess] = useState(false);

    const num1: any = useRef(null);
    const num2: any = useRef(null);
    const num3: any = useRef(null);
    const num4: any = useRef(null);
    const num5: any = useRef(null);
    const num6: any = useRef(null);

    const startLoading = () => {
        setLoading(true);
    };

    const handleBackBtn = () => {
        dispatch(setwizardPageNumber(page - 1));
    };

    const generateTOTP_URL = async (userEnteredTOtp: any) => {
        try {
            const enableMFA = await axios.post(config.NODE_API_BASE_URL + '/wso2/enableMFA',
                { action: 'VALIDATE', verificationCode: userEnteredTOtp },
                {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                }).catch((reason: AxiosError<{ additionalInfo: string }>) => {
                    if (reason.response!.status != 200) {
                        return;
                    }
                });

            if (enableMFA?.data.isValid) {
                return enableMFA?.data.isValid;
            } else {
                return false;
            }
        } catch (error: any) {
            console.error(error);
            fieldsEmpty();
        }
    };

    const submitForm = async (formValues: FormData) => {
        setIsSubmitted(true);
        const userEnteredOtp = `${num1.current?.value}${num2.current?.value || ''}${num3.current?.value || ''}${num4.current?.value || ''}${num5.current?.value || ''}${num6.current?.value || ''}`;

        if (userEnteredOtp == '') {
            setValidatedEmpty(true);
            return;
        }
        startLoading();

        const Response = await generateTOTP_URL(userEnteredOtp);

        if (Response) {
            notifySuccess("TOTP verify successfully");
            return;
        } else {
            notifyError("Invalid TOTP.");
            setIsSubmitted(false);
            return;
        }
    };

    const handleOtpInput = (e: React.ChangeEvent<HTMLInputElement>, nextInputRef: React.RefObject<HTMLInputElement> | null) => {
        const input = e.target;
        const value = input.value;
        setValidatedEmpty(false);
        setValidatedSuccess(false);
        setValidated(false);

        if (value.length === 1 && /^\d$/.test(value)) {
            if (nextInputRef && nextInputRef.current) {
                nextInputRef.current.focus();
            }
        } else {
            input.value = '';
        }
    };

    const fieldsEmpty = () => {
        num1.current.value = "";
        num2.current.value = "";
        num3.current.value = "";
        num4.current.value = "";
        num5.current.value = "";
        num6.current.value = "";
    };

    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
        const pastedText = e.clipboardData.getData('text');

        if (/^\d+$/.test(pastedText) && pastedText.length === 6) {
            const otpArray = pastedText.split('');

            [num1, num2, num3, num4, num5, num6].forEach((ref, index) => {
                if (ref.current) {
                    ref.current.value = otpArray[index];
                }
            });

            if (num6.current) {
                num6.current.focus();
            }

            if (num6.current) {
                handleOtpInput({ target: { value: otpArray[5] } } as React.ChangeEvent<HTMLInputElement>, null);
            }

            e.preventDefault();
        }
    };

    const handleBackspace = (currentRef: React.RefObject<HTMLInputElement>, prevRef: React.RefObject<HTMLInputElement> | null) => {
        if (currentRef && currentRef.current) {
            if (currentRef.current.value === '') {
                if (prevRef && prevRef.current) {
                    prevRef.current.focus();
                }
                if (prevRef && prevRef.current) {
                    prevRef.current.value = '';
                }
            } else {
                currentRef.current.value = '';
            }
        }
    };

    return (
        <>
            <Header />
            <ToastBox />
            <Container fluid className='bg-sky min-vh-custom'>
                <Row>
                    <Col md={12} className='mt-5 text-center'>
                        <br /><br />

                        <div className='mt-5'>
                            <img src={lock} width={55} />
                            <h3 className='text-center mt-3'>{t('login.mfa_title')}</h3>
                        </div>

                        <Form noValidate={true} onSubmit={handleSubmit(submitForm)}>
                            <Row className='justify-content-center py-4'>
                                <Col md={4} className='bg-white py-2 rounded-3'>
                                    <p className='text-secondary small'>{t('login.mfa_enter')}</p>
                                    <p className='text-black mt-2 fw-bold letter-spacing-fix'>{t('login.enter_code')}</p>
                                    <div className="input-group d-flex justify-content-center">
                                        <div className="input-group d-flex justify-content-center">
                                            <input type="number" onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num2)} ref={num1} className='rounded-4 border border-1 otp-input' onPaste={handlePaste} onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(num1, null)} />
                                            <input type="number" onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num3)} ref={num2} className='ms-2 rounded-4 border border-1 otp-input' maxLength={1} onPaste={handlePaste} onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(num2, num1)} />
                                            <input type="number" onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num4)} ref={num3} className='ms-2 rounded-4 border border-1 otp-input' maxLength={1} onPaste={handlePaste} onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(num3, num2)} />
                                            <input type="number" onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num5)} ref={num4} className='ms-2 rounded-4 border border-1 otp-input' maxLength={1} onPaste={handlePaste} onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(num4, num3)} />
                                            <input type="number" onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num6)} ref={num5} className='ms-2 rounded-4 border border-1 otp-input' maxLength={1} onPaste={handlePaste} onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(num5, num4)} />
                                            <input type="number" onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, null)} ref={num6} className='ms-2 rounded-4 border border-1 otp-input' maxLength={1} onPaste={handlePaste} onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(num6, num5)} />
                                        </div>
                                        {validated && <p className='text-danger fw-bold small text-start mt-2 mb-0'>{t('common.otp_invalid')}</p>}
                                        {validatedEmpty && <p className='text-danger fw-bold small text-start mt-2 mb-0'>{t('common.otp_enter_valid')}</p>}
                                        {validatedSuccess && <p className='text-success fw-bold small text-start mt-2 mb-0'>{t('common.otp_sent')}</p>}
                                    </div>
                                    <Container fluid className='mt-3'>
                                        <Link to={''} onClick={handleBackBtn} className="text-primary float-start px-3 py-3 small">{t('common.back')}</Link>
                                        <Button type='submit' className="btn btn-dark float-end mb-2 rounded-5">{t('common.submit')}</Button>
                                    </Container>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Container>
            <Footer full={true} />
        </>
    );
};

const form = reduxForm<{}, Props, FormData>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'wizard',
    enableReinitialize: true,
})(SignInMultifactorAuthenticatorVerification);

export default connect(null)(form);
